module.exports = __webpack_public_path__ + "assets/d5ed504644b1cf650fa38b4c6506bf33.png";